import { render, staticRenderFns } from "./gj-desc-group.vue?vue&type=template&id=258e75c6&scoped=true&"
import script from "./gj-desc-group.vue?vue&type=script&lang=js&"
export * from "./gj-desc-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e75c6",
  null
  
)

export default component.exports